<template>
    <div>
        <v-alert dense text type="success" border="left" class="my-0" v-if="plug.permissionToPlug == 'USER_OK'">
            Associado ao seu usuário
        </v-alert>
        <v-alert dense text type="success" border="left" class="my-0" v-if="plug && plug.unlockBy">
            {{ unlockByText(plug.unlockBy) }}
        </v-alert>
        <v-alert dense text type="success" border="left" class="my-0" v-if="plug && plug.userEmail">
            Email: {{ plug.userEmail }}
        </v-alert>
        <v-alert dense text type="success" border="left" class="my-0" v-if="plug && plug.last4">
            Pago com cartão final: {{ plug.last4 }}
        </v-alert>
        <v-alert dense text type="error" border="left" class="my-0" v-if="showStoppedByUser">
            Parado pelo Usuário
        </v-alert>
        <v-alert dense text type="error" border="left" class="my-0" v-if="plug && plug.feedback && plug.feedback != null && plug.feedback != ChargerFeedback.PROCCESS_OK">
            {{ paymentText(plug.feedback) }}
        </v-alert>
        <v-alert dense text type="error" border="left" class="my-0" v-if="plug && plug.errorSession">
            Sessão de carregamento com problema, carregador fora do padrão.
        </v-alert>

        <v-card :color="componentStyle.color" dark v-if="componentStyle.color" class="pb-4">
            <v-card-text :class="`${componentStyle.secondColor}--text pb-0`" v-if="componentStyle.status">
                <div class="headline mb-sm-2">
                    <v-icon :color="componentStyle.secondColor">{{ componentStyle.icon }}</v-icon>
                    {{ componentStyle.status }}
                </div>
            </v-card-text>

            <ButtonPlug v-if="plug.feedback != ChargerFeedback.WAIT_PLUG || plug.status != 'Available'" :chargerName="chargerName" :charger="charger" :plug="plug" :color="componentStyle.color" :secondColor="componentStyle.secondColor" />

            <div class="d-flex">
                <PartialValue class="half-col" :plug="plug" :secondColor="componentStyle.secondColor" :show="plug.unlockBy == 'PAY' && statusCharger.isOccupied(plug.status)" />
                <v-card-text :class="`half-col text-center ${componentStyle.secondColor}--text pb-0`" v-if="plug.consumption != null && plug.consumption >= 0 && statusCharger.hasStarted(plug.status)">
                    <div class="headline font-weight-bold mb-sm-2 text-no-wrap">{{ Number(plug.consumption).toLocaleString("pt-BR", { maximumFractionDigits: 2 }) }} kWh</div>
                    <div class="d-flex align-center justify-center text-caption text-no-wrap">
                        <v-icon small :color="componentStyle.secondColor" class="mr-1">battery_charging_full</v-icon>
                        Consumo
                    </div>
                </v-card-text>
            </div>
            <IdleTolerance :plug="plug" :secondColor="componentStyle.secondColor" />
            <!-- Informações complementares, com menos destaque que status, valor e consumo -->
            <div class="secondary-info" v-if="statusCharger.isOccupied(plug.status)">
                <v-divider class="mx-4 mt-4" />
                <Battery :plug="plug" :secondColor="componentStyle.secondColor" :show="true" />
                <Power :plug="plug" :secondColor="componentStyle.secondColor" :show="statusCharger.hasStarted(plug.status)" />
                <div class="d-flex">
                    <Time class="half-col" :minutesConnected="plug.minutesConnected" :secondColor="componentStyle.secondColor" title="Tempo conectado" :show="true" />
                    <Time class="half-col" :minutesConnected="plug.minutesCharger" :secondColor="componentStyle.secondColor" title="Tempo carregando" :show="statusCharger.hasStarted(plug.status)" />
                </div>
            </div>
        </v-card>
        <Tips :status="plug.status" :polity="charger.polity" :isPay="charger.price > 0" />
    </div>
</template>

<script>
import dateTime from "@/helpers/DateTime";
import statusCharger from "@/helpers/StatusCharger";
import ChargerFeedback from "@/enum/ChargerFeedback";

import Battery from "./Battery";
import ButtonPlug from "./ButtonPlug";
import IdleTolerance from "./IdleTolerance";
import PartialValue from "./PartialValue";
import Power from "./Power";
import Tips from "./Tips";
import Time from "./Time";

export default {
    components: { Battery, ButtonPlug, IdleTolerance, PartialValue, Power, Tips, Time },

    props: {
        chargerName: {
            required: true,
        },
        charger: {
            required: true,
        },
        plug: {
            required: true,
        },
    },

    data() {
        return {
            ChargerFeedback,
            statusCharger,
            dateTime,
            componentStyle: {
                status: null,
                icon: null,
                color: null,
                secondColor: null,
            }
        };
    },

    computed: {
        showStoppedByUser() {
            return this.plug && this.statusCharger.isOccupied(this.plug.status) && this.plug.stoppedForced;
        },
    },

    methods: {
        unlockByText(unlockBy) {
            switch (unlockBy) {
                case "FREE_POWER":
                    return this.charger.price > 0 ? "Aguardando pagamento para liberação de potência." : "Liberado com baixa potência, aguardando ativação do usuário."
                case "APP":
                    return "Liberado por aplicativo"
                case "NFC":
                    return "Liberado por cartão NFC"
                case "PAY":
                    return "Liberado por pagamento"
                default:
                    return "-";
            }
        },
        paymentText(payment) {
            if (payment == ChargerFeedback.WAIT_PLUG) {
                return "Pagamento feito com sucesso, conecte o carro no carregador."
            } else if (payment == ChargerFeedback.WAIT_UNLOCK) {
                return "Pagamento feito com sucesso, aguardando desbloqueio do carregador."
            } else {
                return `Erro ao efetuar transação com a operadora do cartão: ${payment}`;
            }
        }
    },

    watch: {
        plug: {
            immediate: true,
            handler() {
                this.componentStyle = { ...this.statusCharger.getComponentStyle(this.plug.status) };
            },
        },
    },
}
</script>

<style scoped>
.secondary-info {
    opacity: 0.85;
}

.half-col {
    flex: 1 1 0;
    min-width: 0;
}
</style>
